import React, { useEffect, useState } from "react";
import { Form, Input, Checkbox } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingClassModuleDetails, 
	doTrainingClassModuleCreate, 
	doTrainingClassModuleUpdate,  
} from "../../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { BookOpen } from "lucide-react";

const TrainingClassModuleForm = ({
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData,
	classeId,
	getDetails,
	submitLabel,
	...props
 }) => {
		
  	const [form] = Form.useForm();
  	const { recordId, mode } = props;
	const [selectedModules, setSelectedModules] = useState([]);
	
	useEffect(() => {	
		if (recordData) {
			form.resetFields();
			const {class_module:classModule, ...rest } = recordData;

			if (rest.tcm_user_id === 0) {
      			delete rest.tcm_user_id;
			
			};
				form.setFieldsValue({
				...rest,
      			tcm_class_id: classeId,
				});
		}
	}, [recordData, classeId, form]);

	useEffect(() => {
		if (classeId && recordId === 0) {
			getDetails({ classeId, moduleId : 0 });
		}
	}, [classeId, recordId, getDetails]);

	const toggleModule = (moduleId) => {
		setSelectedModules((prev) =>
			prev.includes(moduleId)
				? prev.filter((id) => id !== moduleId)
				: [...prev, moduleId]
			);
	};
   
  	const onSubmit = (formData) => {
		try { 
			formData.tcm_class_id=classeId;
			formData.tcm_module_id = selectedModules;

		if (!formData.tcm_user_id || formData.tcm_user_id === 0) {
      		delete formData.tcm_user_id;}

			recordData?.tcm_id > 0 ? doUpdate(formData): doCreate(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

  
  	return (
		<Form 	
			layout="vertical"
			form={form}
			onFinish={onSubmit}
			className={mode !== "view" ? "form" : ""}
		>

			<FormItem 
				name="tcm_id" 
				hidden
			>
				<Input type="hidden" />
			</FormItem>

			<div>
				<FormItem
					name="tcm_module_id"
				>
					<h1 className="text-slate-900 dark:text-slate-50">Module List</h1>
					<div className="h-[340px] overflow-auto space-y-3 mt-2 pr-2">
						{recordData?.trainingModuleList?.length > 0 ? (
							recordData.trainingModuleList.map((module) => {
								const selected = selectedModules.includes(module.value);
								const disabled = module.disabled;
								return (
									<div
										key={module.value}
										className={`flex items-center gap-3 p-2.5 rounded-xl border-2 transition-all
											${disabled
												? "opacity-50 cursor-not-allowed border-slate-200 bg-slate-50"
												: selected
												? "border-green-500 bg-green-50 cursor-pointer"
												: "border-slate-200 hover:border-emerald-300 hover:bg-slate-50 cursor-pointer"
											}`}
										onClick={() => !disabled && toggleModule(module.value)} 
									>
										<Checkbox
											checked={selected}
											disabled={disabled}
											onChange={() => toggleModule(module.value)}
											className="emerald-checkbox"
										/>
											<div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-purple-600">
												<BookOpen className="w-5 h-5 text-white" />
											</div>
											<div className="flex-1">
												<p className="font-semibold text-[13px] title-text">
													{module.label}
												</p>
												<p className="text-[11px] muted-text">
													{module.description}
												</p>
											</div>
									</div>
								);
							})
						) 	: 	(
							<div className="flex flex-col items-center justify-center py-12 text-center muted-text">
								<BookOpen className="w-10 h-10 mb-2" />
								<p>No modules found</p>
							</div>
						)}
					</div>
				</FormItem>
			</div>

			{mode === "edit" && (
				<div className="w-full flex justify-end mt-6">
					<CrudButtons
						mode={mode}
						recordId={recordData?.tcm_id ?? 0}
						isModal={true}
						allowEdit={false}
						modalId={
							recordData?.tcm_id > 0
								? "edit_class_module"
								: "add_class_module"
							}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel="Add Module"
					/>
				</div>
			)}
		</Form> 
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingClass.trainingClassModuleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getDetails: (data) => dispatch(getTrainingClassModuleDetails(data)),
  	doCreate: (data) => dispatch(doTrainingClassModuleCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingClassModuleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassModuleForm);
